import { ActionMenuItem, BaseActionEnum, BaseActions } from "../../components/action-menu/ActionMenuItem";
import i18n from "../../services/localization-service/i18n";
import { getActionMenuItems } from "../action-menu/BaseActions";
import { MyScheduledReportsIcon } from "../action-menu/ActionMenuIcons";

export enum ReportViewActionEnum {
    MyScheduledReports = "myscheduledreports"
}

export type ReportViewActionItem = {
    action: ReportViewActionEnum | BaseActions | string;
} & ActionMenuItem;

const actionEnums = [
    BaseActionEnum.Configure,
    BaseActionEnum.Favorite
];

export const actionItems = [...getActionMenuItems(actionEnums), {
    id: "myreports",
    label: i18n.t("actions.myScheduledReports"),
    icon: MyScheduledReportsIcon,
    action: ReportViewActionEnum.MyScheduledReports,
    order: 2
}];
